import React from 'react'

import { lazily } from 'react-lazily'
import { Navigate, Route, Routes } from 'react-router-dom'

import { AllAlerts } from '@UI/crypto_exchange/desktop/pages/all_alerts'

import { Loader } from '../components/common/Loader'
import { CalendarPage } from '../pages/calendar'
import { ReportsContainer } from '../pages/reports'

import { PrivateRoute } from './PrivateRoutes'
import { ROUTE_NAMES } from './routeNames'

const { SpotOrderContainer } = lazily(
  () => import('@UI/crypto_exchange/desktop/pages/spot/containers/SpotOrderContainer'),
)

const { HistoryContainer } = lazily(
  () => import('@UI/crypto_exchange/desktop/pages/history/containers/HistoryContainer'),
)

const { LoginContainer } = lazily(
  () => import('@UI/crypto_exchange/desktop/pages/authorization_pages/containers/LoginContainer'),
)
const { VerificationContainer } = lazily(
  () => import('@UI/crypto_exchange/desktop/pages/authorization_pages/containers/VerificationContainer'),
)
const { RegistrationContainer } = lazily(
  () => import('@UI/crypto_exchange/desktop/pages/authorization_pages/containers/RegistrationContainer'),
)

const { ResetPasswordContainer } = lazily(
  () => import('@UI/crypto_exchange/desktop/pages/authorization_pages/containers/ResetPasswordContainer'),
)

const { NotFoundPageContainer } = lazily(() => import('@UI/crypto_exchange/desktop/pages/not_found_page'))

const { DiscoverPage } = lazily(() => import('@UI/crypto_exchange/desktop/pages/discover'))
const { ChartsContainer } = lazily(() => import('@UI/crypto_exchange/desktop/pages/charts'))

export const RouterContainer = () => {
  return (
    <React.Suspense fallback={<Loader />}>
      <Routes>
        <Route path={ROUTE_NAMES.HOME} element={<Navigate to={ROUTE_NAMES.TRADING} replace />} />
        <Route path={ROUTE_NAMES.LOGIN} element={<LoginContainer />} />
        <Route path={ROUTE_NAMES.TWO_FA} element={<VerificationContainer />} />
        <Route path={ROUTE_NAMES.REGISTRATION} element={<RegistrationContainer />} />
        <Route path={ROUTE_NAMES.CALENDAR} element={<CalendarPage />} />

        <Route path={ROUTE_NAMES.RESET_PASSWORD} element={<ResetPasswordContainer />} />

        <Route path={ROUTE_NAMES.TRADING} element={<SpotOrderContainer />} />
        <Route path={ROUTE_NAMES.CHARTS} element={<ChartsContainer />} />

        <Route path={ROUTE_NAMES.DISCOVER} element={<DiscoverPage />} />
        <Route path={ROUTE_NAMES.ALL_ALERTS} element={<AllAlerts />} />

        <Route element={<PrivateRoute />}>
          <Route path={ROUTE_NAMES.HISTORY} element={<HistoryContainer />} />
          <Route path={ROUTE_NAMES.REPORTS} element={<ReportsContainer />} />
        </Route>
        <Route path="*" element={<NotFoundPageContainer />} />
      </Routes>
    </React.Suspense>
  )
}
